import { useMemo } from 'react';
import { useField } from '@arc/frontend/util-common';
import { FormControl } from '../FormControl';
import { SelectorSelect } from './SelectorSelect';
export function convertItemsToLookUp(items, formatFunc) {
  // eslint-disable-next-line unicorn/no-array-reduce
  return items.reduce((table, item) => {
    return {
      keys: [...table.keys, formatFunc(item)],
      lookUp: {
        ...table.lookUp,
        [formatFunc(item)]: item
      },
      reverseLookUp: {
        ...table.reverseLookUp,
        [item]: formatFunc(item)
      }
    };
  }, {
    keys: [],
    lookUp: {},
    reverseLookUp: {}
  });
}
export function SelectorSelectWithLookupAndControl(props) {
  const {
    label,
    defaultValue,
    lookup,
    outerStyle,
    infoText,
    sortAlphabetically = true
  } = props;
  const reverseLookup = useMemo(() => Object.fromEntries(Object.keys(lookup).map(key => [lookup[key], key])), [lookup]);
  const {
    field: {
      onChange,
      value: formValue,
      ref
    },
    fieldState: {
      invalid: error
    },
    errorMessage
  } = useField({
    name: props.name,
    defaultValue: defaultValue ? lookup[defaultValue] : defaultValue
  });
  return <FormControl error={error} helperText={errorMessage} label={label} labelStyle={props.labelStyle} outerStyle={outerStyle} infoText={infoText}>
			<SelectorSelect inputRef={ref} value={formValue && reverseLookup?.[formValue] ? reverseLookup[formValue] : ''} onChange={displayValue => {
      onChange(displayValue && lookup?.[displayValue] ? lookup[displayValue] : '');
    }} items={Object.keys(lookup).filter(key => !props.filterList || props.filterList(key)).sort((a, b) => sortAlphabetically ? a.localeCompare(b) : 0)} dropdownMaxHeight="auto" {...props} error={error} />
		</FormControl>;
}